import { Backdrop, Box, Button, CircularProgress, IconButton, Portal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export interface ConfirmActionAlertProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly title: string;
  readonly description: string;
  readonly confirmLabel: string;
  readonly onConfirm: () => void;
  readonly isPending?: boolean;
}

const ConfirmActionAlert = ({ open, onClose, title, description, confirmLabel, onConfirm, isPending = false }: ConfirmActionAlertProps) => {
  if (!open) {
    return null;
  }

  return (
    <Portal>
      <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.modal }} onClick={() => !isPending && onClose()} />
      <Box
        role="alertdialog"
        aria-modal="true"
        sx={{
          position: "fixed",
          top: "45%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: (theme) => theme.zIndex.modal + 1,
          width: "min(680px, calc(100vw - 32px))",
          display: "flex",
          alignItems: "flex-start",
          gap: 1.5,
          px: 2,
          py: 1.5,
          bgcolor: "#29b6f6",
          color: "#000",
          borderRadius: 1,
          boxShadow: 6
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 22, mt: 0.25, flexShrink: 0 }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontWeight: 500, fontSize: "1rem", lineHeight: 1.5, letterSpacing: "0.15px" }}>{title}</Typography>
          <Typography sx={{ fontWeight: 400, fontSize: "0.875rem", lineHeight: 1.43, letterSpacing: "0.17px" }}>{description}</Typography>
        </Box>
        <Button
          variant="text"
          size="small"
          onClick={onConfirm}
          disabled={isPending}
          sx={{ color: "#000", fontWeight: 500, fontSize: "0.8125rem", lineHeight: "22px", letterSpacing: "0.46px", whiteSpace: "nowrap", minWidth: 64 }}
        >
          {isPending ? <CircularProgress size={16} sx={{ color: "#000" }} /> : confirmLabel}
        </Button>
        <IconButton
          aria-label="Close"
          size="small"
          disabled={isPending}
          onClick={onClose}
          sx={{ color: "rgba(0, 0, 0, 0.87)", mt: -0.5, mr: -0.5 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Portal>
  );
};

export default ConfirmActionAlert;
